import ConditionalToolTip from "components/design/conditionalToolTip";
import { Button } from "components/DesignSystem/Button/Button";
import { CountBadge } from "components/DesignSystem/Tag/CountBadge";
import { LinkInvoiceToTransactionModal } from "components/InvoiceAction/LinkInvoiceToTransactionModal";
import { AIOutlinedIcon } from "components/icons/AIOutlinedIcon";
import { WRITE_PERMISSION_KEYS } from "constants/permissions";
import { BILL_STATUS } from "constants/vendorBills";
import { useHasWritePermission } from "hooks/useHasWritePermission";
import { useModal } from "hooks/useModal";
import { VendorBill } from "types/Models/vendorBills";
import { pluralize } from "utils/pluralize";

export const BillAiSuggestionIndicator = ({ bill }: { bill: VendorBill }) => {
  const linkViaModal = useModal();
  const hasWritePermission = useHasWritePermission(
    WRITE_PERMISSION_KEYS.EXPENSE
  );

  const transactionsCount = bill.suggested_txns?.length || 0;
  const hasSuggestions = transactionsCount > 0 && hasWritePermission;

  const isRecordPaymentAllowed =
    bill.bill_payment_status === BILL_STATUS.DUE ||
    bill.bill_payment_status === BILL_STATUS.OVERDUE ||
    bill.bill_payment_status === BILL_STATUS.PARTIALLY_PAID;

  const handleAIClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    linkViaModal.open();
  };

  return (
    <div className="t-flex t-w-8 t-justify-center">
      {hasSuggestions && (
        <>
          <ConditionalToolTip
            condition={isRecordPaymentAllowed}
            text={`Inkle AI found ${pluralize(
              transactionsCount,
              "potential payment match",
              "potential payment matches"
            )}`}
          >
            <div className="t-relative t-inline-flex">
              <Button customType="ghost" size="xsmall" onClick={handleAIClick}>
                <AIOutlinedIcon />
              </Button>
              <CountBadge count={transactionsCount} />
            </div>
          </ConditionalToolTip>

          <div onClick={(e) => e.stopPropagation()}>
            <LinkInvoiceToTransactionModal
              invoiceId={bill.uuid}
              type="BILL"
              isOpen={linkViaModal.isOpen}
              close={linkViaModal.close}
              openSuggestedMatches
            />
          </div>
        </>
      )}
    </div>
  );
};
